// General
import "./video-gradient-overlay.scss";

const VideoGradientOverlay = () => {
  return <div id="video-call-video-gradient-overlay"></div>;
};

export default VideoGradientOverlay;
